/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Enumeration representing the sorting order of a datagrid column. It is a constant Enum,
 * i.e. each value needs to be treated as a `number`, starting at index 0.
 *
 * @export
 * @enum {number}
 */
/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */ export var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["Unsorted"] = 0] = "Unsorted";
    SortOrder[SortOrder["Asc"] = 1] = "Asc";
    SortOrder[SortOrder["Desc"] = -1] = "Desc";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=sort-order.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/interfaces/sort-order.js
// module id = 164
// module chunks = 4